export function getAudioForSource(source: string | null | undefined): HTMLAudioElement | null {
    if (!source) {
        return null;
    }

    return new Audio(source);
}